import Vue from 'vue'
import Sum from '@/components/Utils/Sum.vue'

Vue.component('sum', Sum)
